// extracted by mini-css-extract-plugin
export var root = "PdpGwpDialog-module--root--Tzj6T";
export var images = "PdpGwpDialog-module--images--FGcuE";
export var details = "PdpGwpDialog-module--details--l-RHS";
export var gwpMessage = "PdpGwpDialog-module--gwpMessage--v2x+h";
export var addToCart = "PdpGwpDialog-module--addToCart--mzZ3b";
export var productDescriptionShow = "PdpGwpDialog-module--productDescriptionShow--dABSw";
export var options = "PdpGwpDialog-module--options--WYBFS";
export var preorderDetail = "PdpGwpDialog-module--preorderDetail--4MhOk";